import Notification from './Notification';
export type { NotificationProps } from './Notification.types';
export { NOTIFICATION_LOOK } from './Notification.types';

export default Notification;
